export default __webpack_public_path__ + "static/media/vitra_chair_09.14a49589.jpg";